import { useEffect } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import { getNextOnboardingStepHref, isOnboarding } from "@/modules/onboarding";
import removeTrailingSlash from "@/utils/remove-trailing-slash";
import { useAuthContext } from ".";

import { useAuthStateChange } from "./hooks/use-auth-state-change";

const useAuthFormPath = () => {
  const { pathname: unsanitizedPathname } = useLocation();
  const pathname = removeTrailingSlash(unsanitizedPathname);
  const isAuthForm = ["/login", "/sign-up"].includes(pathname);

  return { pathname, isAuthForm };
};
export default function AuthGate() {
  const { getSession } = useAuthContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthForm } = useAuthFormPath();

  useEffect(() => {
    getSession().then((session) => {
      if (session && isAuthForm) {
        const onboardingStepHref =
          isOnboarding(searchParams) &&
          getNextOnboardingStepHref(searchParams, true);

        if (onboardingStepHref) {
          return navigate(onboardingStepHref);
        }
        return navigate("/");
      }

      if (!session && !isAuthForm) {
        return navigate("/login");
      }
    });
  }, []);

  const { onSignedIn, onSignedOut } = useAuthStateChange();

  onSignedIn(() => {
    if (isAuthForm) {
      navigate("/");
    }
  });
  onSignedOut(() => !isAuthForm && navigate("/login"));

  return <Outlet />;
}
